import * as types from '../../constants/wallet/depositConstants';
import {CONTENTS_WALLET_LIST_REQUEST} from "../../constants/wallet/depositConstants";

export const depositAddressRequest = ({
  walletNo,
  callback,
  error,
}) => ({
  type: types.DEPOSIT_ADDRESS,
  walletNo,
  callback,
  error,
});

export const depositRequest = ({
  walletNo,
  tokenType,
  amount,
  walletAddress,
  callback,
  error,
}) => ({
  type: types.DEPOSIT_REQUEST,
  walletNo,
  tokenType,
  amount,
  walletAddress,
  callback,
  error,
});

export const ContentsWalletListRequest = ({
                                            callback,
                                            error,
}) => ({
  type : types.CONTENTS_WALLET_LIST_REQUEST,
  callback,
  error,
});